import React from 'react';
import { makeStyles } from '@material-ui/core';
import {
  Paper,
  InputBase,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Box,
  Button,
} from '@material-ui/core'

import clsx from 'clsx'
// import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search'
// import DirectionsIcon from '@material-ui/icons/Directions'

const useStyles = makeStyles({
  root: {
    padding: '6px 4px',
    display: 'flex',
    alignItems: 'center',
    width: 400,
  },
  selectPaper: {
    padding: '2px 13px',
  },
  input: {
    marginLeft: 8,
    flex: 1,
    height: 44,
  },
  iconButton: {
    padding: '0px 16px',
    minWidth: 48,
    marginLeft: 10,
    marginTop: 0,
    marginBottom: 0
  },
  searchButtonLabel: {
    fontSize: '1.025rem'
  },
  divider: {
    width: 1,
    height: 28,
    margin: 4,
  },
  select: {
    marginTop: '0!important',
    height: 44,
    '&:before': {
      content: 'none',
    },
    '&:after': {
      content: 'none',
    },
  },
  formControl: {
    marginTop: 0,
  },
  selectLabel: {
    transform: 'translate(0, 15px) scale(1)',
  },
  selectFocus: {
    transform: 'translate(0, 15px) scale(1)',
    opacity: 0,
  },
  shrink: {
    transform: 'translate(0, 15px) scale(1)',
    opacity: 0,
  },
  selectInside: {
    paddingRight: 40,
  },
  searchBox: {
    padding: 0,
    margin: 0,
    display: 'flex',
  },
  searchIcon: {
    marginRight: 5
  }
})

const SearchInput = props => {
  const classes = useStyles()
  return <InputBase className={classes.input} {...props} />
}

const SearchBox = props => {
  const { children } = props
  const classes = useStyles()
  return (
    <Box component="div" m={5} className={classes.searchBox}>
      <Paper className={clsx(classes.root, classes.selectPaper)}>{children}</Paper>
      <Button className={classes.iconButton} classes={{label: classes.searchButtonLabel}} color="primary" variant="contained">
        <SearchIcon className={classes.searchIcon} type="submit" /> 搜尋
      </Button>
    </Box>
  )
}

const SearchSelect = props => {
  const classes = useStyles()
  const { label, name, option, ...restProps } = props
  return (
    <FormControl className={classes.formControl}>
      <InputLabel
        htmlFor={name}
        className={classes.selectLabel}
        classes={{
          focused: classes.selectFocus,
          shrink: classes.shrink,
        }}
      >
        {label}
      </InputLabel>
      <Select
        {...restProps}
        variant="standard"
        classes={{ select: classes.selectInside }}
        className={classes.select}
      >
        {option.map(opt=> <MenuItem value={opt.value} key={opt.value}>{opt.label}</MenuItem>)}
      </Select>
    </FormControl>
  )
}

export { SearchInput, SearchSelect, SearchBox }
